module.exports = __webpack_public_path__ + "images/avatars/male/2.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/2.png
// module id = Z9aV
// module chunks = 153